/**
 * 首页
 */
export const MENU_HOME = 'home'

/**
 * 司仪档期
 */
export const MENU_SCHEDULE_TOOL = 'scheduleTool'

/**
 * 客资管理
 */
export const MENU_CRM = 'customer'
export const MENU_CUSTOMER_LIST = 'customerManage'
export const MENU_POTENTIAL_CUSTOMERS = 'potentialCustomers'

/**
 * 订单、收入管理
 */
export const MENU_BUSSINESS = 'business'
export const MENU_ORDER = 'orderManage_new'
export const MENU_INCOME = 'incomeManage'
export const MENU_EXPERIENCE_SHOP_COOP = 'experienceShopManage'

/**
 * 店铺管理
 */
export const MENU_SHOP = 'shopManage'
export const MENU_DECORATION = 'decoration'
export const MENU_APPRAISE = 'appraise'
export const MENU_INFO = 'editStore'
export const MENU_NOTICE = 'notice'
export const MENU_CERTIFICATION = 'certification'
export const MENU_BRAND = 'brand'

/**
 * 内容管理
 */
export const MENU_CONTENT = 'contentManage'
export const MENU_VR = 'vr'
export const MENU_MEAL = 'setMeal'
export const MENU_SINGLE_PRODUCT = 'singleProduct'
export const MENU_EXAMPLE = 'case'
export const MENU_DYNAMIC = 'dynamic'
export const MENU_PLANNER = 'panner' // 策划师
export const MENU_PHOTOGRAPHY = 'photography' // 摄影师

/**
 * 内容中心
 */
export const MENU_CONTENT_CENTER = 'contentCenterRoot'
export const MENU_CONTENT_CENTER_INDEX = 'contentCenter'
export const MENU_CONTENT_CENTER_CREATION = 'creation' // 我的创作

/**
 * 营销中心
 */
export const MENU_MARKETING = 'marketing'
export const MENU_MARKETCENTER = 'marketingCenter'
export const MENU_ACTIVITYREGISTER = 'activityRegister'
export const MENU_LIVE_MANAGE = 'liveManage' // 直播管理

/**
 * 团队管理（三大、司仪类目）
 */
export const MENU_MEMBER_MANAGE = 'groupManage'
export const MENU_MEMBER_MANAGE_HOME = 'groupHome'
export const MENU_MEMBER_MANAGE_SCHEDULE = 'groupSchedule'
export const MENU_MEMBER_MANAGE_MEMBER = 'groupMember'
export const MENU_MEMBER_MANAGE_SETTING = 'groupSetting'

/**
 * 推广中心
 */
export const MENU_POPULARIZATION_CENTER = 'popularization_center'
export const MENU_POPULARIZATION_CENTER_HOME = 'popularization' // 首页
export const MENU_ZHITUIBAO = 'zhiTuiBao' // 智推宝
export const MENU_PROMOTION = 'zhiGuangTong' //  智优投
export const MENU_CREATIVE_CENTER = 'creativeCenter' // 创意中心

/**
 * 体验店推荐
 */
export const MENU_EXPERIENCE_SHOP = 'experienceShop'

/**
 * 客资推荐
 */
export const MENU_CUSTOMER_RECOMMEND = 'customerInfo'

/**
 * 小程序
 */
export const MENU_LITE_APP = 'liteApp'

/**
 * 海草名片小程序
 */
export const MENU_NAME_CARD = 'nameCard'
export const MENU_NAME_CARD_MANAGE = 'nameCardManage'

/**
 * 转介绍图集管理
 */
export const NAME_CARD_ATLAS_MANAGE = 'atlasManage'

/**
 * 客服账号管理
 */
export const MENU_STUFF = 'serviceManage'
export const MENU_STUFF_ACCOUNT = 'serviceAccount'

/**
 * 设置
 */
export const MENU_SETTING = 'setting'
export const MENU_ACCOUNT = 'accountManage'
export const MENU_REALNAME_AUTH = 'realnameAuthentication'
export const MENU_BOND = 'bond'

export const MENU_SELLERSERVICE_AUTH = 'sellerService'
export const MENU_SETTLEMENTACCOUNT_AUTH = 'settlementAccount'

export const MENU_SCHEDULE = 'schedule'

/**
 * 加盟店特有菜单
 */
export const MENU_JIAMENG_SHOP = 'decoration'
export const MENU_JIAMENG_GOODS = 'jiaMengGoods'
export const MENU_JIAMENG_CUSTOMER = 'customerManage'
export const MENU_JIAMENG_COOPERATION = 'cooperation'
export const MENU_JIAMENG_NEW_CUSTOMER = 'newCustomer' // 加盟店客户管理（替代原客资）
export const MENU_JIAMENG_ORDER = 'orderManage_new'
export const MENU_JIAMENG_MARKETING = 'marketingCenter'
export const MENU_JIAMENG_SCHEDULE = 'schedule'
export const MENU_JIAMENG_STATS = 'stats'
export const MENU_JIAMENG_SETTING = 'sellerService'

/**
 * 数据中心
 */
export const MENU_DATA_CENTER = 'dataCenter'
export const MENU_SHOP_DATA = 'shopData'
export const MENU_CONTENT_DATA = 'contentData'
export const MENU_DECORATION_ANALYSIS = 'decorationAnalysis'

/**
 * 酒店菜单暂时放在这里
 */

//酒店经营管理
export const MENU_HOTEL_BUSINESS = 'hotelBusiness'
export const MENU_HOTEL_MY_ORDER = 'myOrder'
export const MENU_HOTEL_ORDER_FEEDBACK = 'orderFeedback'
export const MENU_HOTEL_SETTLE_MANAGE = 'settlementManage'

// 酒店信息
export const MENU_HOTEL_INFO = 'hotelInfo'
export const MENU_HOTEL_INFO_BASIC = 'editStore'
export const MENU_HOTEL_PREFERENCE = 'exclusiveOffers'
export const MENU_HOTEL_UNIQUE_INFO = 'uniqueInfo'
export const MENU_HOTEL_THEME_TEMPLATE = 'themeChose'

// 酒店管理
export const MENU_HOTEL_MANAGE = 'hotelManage'
export const MENU_HOTEL_COVER = 'coverSetting'
export const MENU_HOTEL_ALBUM = 'albumManage'
export const MENU_HOTEL_MENU = 'menuManage'
export const MENU_HOTEL_MEAL = 'mealManage'
export const MENU_HOTEL_SITE = 'siteManage'
export const MENU_HOTEL_MATERIAL = 'materialLibrary'
export const MENU_HOTEL_VR = 'vr'
export const MENU_HOTEL_OSSM = 'ossm' // 一站式服务管理 One stop service management

// 酒店档期管理
export const MENU_HOTEL_SCHEDULE_MANAGE = 'hotelScheduleManage'
export const MENU_HOTEL_SCHEDULE_LIST_MODE = 'listMode'
export const MENU_HOTEL_SCHEDULE_CALENDAR_MODE = 'calendarMode'
